module.exports = __webpack_public_path__ + "static/05_home_screen_v3.17d0a56d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/project6/05_home_screen_v3.jpg
// module id = 514
// module chunks = 111663361672460